import { createFileRoute, redirect } from "@tanstack/react-router";
import { RegisterTemplate } from "~/features/auth/RegisterTemplate";
import { getHomePath } from "~/lib/applicationId";
import { useAuthStore } from "~/stores/useAuthStore";

export const Route = createFileRoute("/register")({
  beforeLoad: () => {
    const token = useAuthStore.getState().token;
    if (token) {
      throw redirect({ to: getHomePath() });
    }
  },
  component: RegisterTemplate,
});
